<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div class="headline">Currency Listing</div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="itemsPerPage" :pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.curr }}</td>
          <td class="text-xs-left">{{ props.item.currDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview(props.item.curr)" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="primary" dark class="mb-2" @click="doNew">
      New Currency
      <v-icon right>mdi-plus</v-icon>
    </v-btn>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected item?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'Currency', value: 'curr' },
        { text: 'Description', value: 'currDesc' },
        TableConst.tableActionHeader
      ],
      selectedId: {
        id: null,
        text: null
      },
      promptRemove: false
    }
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.selectedId.id = null
      this.selectedId.text = null
      const apiUrl = this.currMenu.getAllCurrency
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          this.items = []
          if (data) {
            data.map(curr => {
              const convertList = {
                curr: curr.curr,
                currDesc: curr.currDesc
              }
              this.items.push(convertList)
            })
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.fullMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
      this.loading = false
    },
    doReview(curr) {
      const redirect = {
        name: 'currReview',
        params: {
          curr
        }
      }
      this.$router.push(redirect)
    },
    doNew() {
      const redirect = {
        name: 'currReview',
        params: {
          curr: 'new'
        }
      }
      this.$router.push(redirect)
    },
    doPromptRemove(currency) {
      this.resetMessages()
      this.selectedId.id = currency.curr
      this.selectedId.text = currency.curr + ' - ' + currency.currDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.currMenu.deleteCurrency
      if (apiURI) {
        const expand = {
          curr: this.selectedId.id
        }
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.doFetch()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  created() {
    this.doFetch()
  },
  computed: {
    currMenu() {
      return this.$store.state.currency.menu
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
